import { render, staticRenderFns } from "./AboutPetLottie.vue?vue&type=template&id=34b9a3da&"
import script from "./AboutPetLottie.vue?vue&type=script&lang=js&"
export * from "./AboutPetLottie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports